export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.weivered-bills-report.index`,
        path: `/${prefix}/${pre}/weivered-bills-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.weivered-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: Weivered Bills report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.weivered-bills-report.index`,
        path: `/${prefix}/${pre}/weivered-bills-report/print`,
        component: () => import('./prints/WeiveredBillsReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.weivered-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: Weivered Bills report",
            },
            print:true,
        },
    },
    {
        name: `${prefix}.${pre}.print.weivered-bills-details.index`,
        path: `/${prefix}/${pre}/weivered-bills-details/print`,
        component: () => import('./prints/WeiverBillDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.weivered-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: Weivered Bills report",
            },
            print:true,
        },
    },
];